<template>
  <div class="das-dropdown" :class="{ 'dd-placeholder': !editInput }" @click.stop="toggleList()">
    <div class="text-inline" :id="`selected-activity-text-${id}`">
      {{ editInput ? editInput : defaultDropdownText[defaultText] }}
      <span class="activity-count" v-if="inputArrCount && inputArrCount > 1">{{ inputArrCount }}</span>
      <!-- Tool-tip for selected long text -->
      <b-popover :boundary="'viewport'" v-if="id && editInput && editInput.length > 54" :target="`selected-activity-text-${id}`" triggers="hover" placement="left">
        <template v-slot:content>
          <div class="popover-content" :class="editInput && editInput.length < 54 ? 'small-text' : 'large-text'">
            {{ editInput }}
          </div>
        </template>
      </b-popover>

      <sup class="red-asterisk" v-if="!editInput">*</sup>
    </div>
    <span class="caret"></span>
    <ul :class="{ 'display-block': showList, 'display-none': !showList }">
      <li class="search-box-li">
        <div class="search-wrapper">
          <input type="search" v-model="search" placeholder="Search for an activity" @click.stop="" />
          <span v-show="search && search.length > 0" @click.stop="clearSearch()" class="search-cross"> </span>
        </div>
      </li>

      <li :class="{ 'display-block': showList, 'display-none': !showList }" v-for="(opt, index) in filteredList" :key="index" @click.stop="">
        <div class="row dropdown-list-item clearInputStyles" @click.stop="">
          <input class="col-md-1" type="checkbox" :value="opt.taskID" v-model="selectedDataIDsArr" @change.stop="selectedData(opt)" @click.stop="" />
          <div v-if="id" :id="`activity-name-${opt.taskID}-${id}`" class="text-ellipsis col-md-7">
            {{ opt[optionField] }}
          </div>
          <div v-if="id" :id="`activity-type-${opt.taskID}-${id}`" class="text-ellipsis col-md-4">
            {{ displayTaskType(opt["taskType"]) }}
          </div>
        </div>

        <b-popover :boundary="'viewport'" v-if="id && opt[optionField].length > 20" :target="`activity-name-${opt.taskID}-${id}`" triggers="hover" placement="right">
          <template v-slot:content>
            <div class="popover-content" :class="opt[optionField].length < 20 ? 'small-text' : 'large-text'">
              {{ opt[optionField] }}
            </div>
          </template>
        </b-popover>

        <b-popover :boundary="'viewport'" v-if="id && displayTaskType(opt['taskType']).length > 14" :target="`activity-type-${opt.taskID}-${id}`" triggers="hover" placement="right">
          <template v-slot:content>
            <div class="popover-content" :class="displayTaskType(opt['taskType']).length < 14 ? 'small-text' : 'large-text'">
              {{ displayTaskType(opt["taskType"]) }}
            </div>
          </template>
        </b-popover>
      </li>
      <li class="dd-placeholder" v-if="!filteredList.length" @click.stop="">
        No available activities
      </li>
    </ul>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import * as DynamicSchedulingConstants from "@/constants/dynamicSchedulingConstants";

export default {
  name: "das-dropdown-search",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    optionField: {
      type: String,
      default: ""
    },
    defaultText: {
      type: String,
      default: null
    },
    input: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    actionData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultDropdownText: {
        trigger: "Select Trigger",
        participantInfo: "Select a Field",
        milestone: "Select Milestone(s)",
        language: "Select Language(s)",
        birthDate: "Select a Date",
        country: "Select a Country",
        gender: "Select Gender",
        taskDetails: "Select an Activity"
      },
      showList: false,
      selectedText: null,
      selectedDataArr: [],
      tempSelectedDataArr: [],
      search: "",
      tempMultipleActivitySelected: [],
      inputArrCount: null,
      selectedDataIDsArr: [],
      actionType: null
    };
  },
  created() {
    this.$root.$on("close-all-drop-downs", data => {
      if (data == "all" || data !== this.id) {
        this.showList = false;
      }
    });
  },
  methods: {
    toggleList() {
      this.showList = !this.showList;
      this.$root.$emit("close-all-drop-downs", this.id); // this will close only single dropdown( single )
    },
    selectedData(data) {
      this.showList = true;
      this.selectedText = data[this.optionField];
      this.restrictActivitySelection(data);
      this.tempSelectedDataArr = this.convertIdListToDataList(this.options, this.selectedDataIDsArr, "taskID");
      this.clearSearch();
      this.$emit("selected-data", this.tempSelectedDataArr);
    },
    convertDataListToIdList(list, key) {
      return list && list.map(val => val[key]);
    },
    convertIdListToDataList(list, IdList, key) {
      const finalList = [];
      for (const data of list) {
        for (const id of IdList) {
          if (data[key] === id) {
            finalList.push(data);
            break;
          }
        }
      }
      return finalList;
    },
    clearSearch() {
      this.search = "";
      this.filteredList = cloneDeep(this.options);
    },
    displayTaskType(taskType) {
      if (taskType === "activity") {
        // When activity is an ERDO
        return "eDRO";
      } else if (taskType === "epro") {
        return "PRO";
      } else if (taskType === "survey") {
        return "Survey";
      } else if (taskType === "telehealth") {
        return "Telehealth";
      } else if (taskType === "edro") {
        // When activity is a DRO
        return "DRO";
      } else if (taskType === "task") {
        // When activity is a Task
        return "Task";
      } else {
        return taskType;
      }
    },
    restrictActivitySelection(task) {
      if (this.selectedDataIDsArr.length > DynamicSchedulingConstants.ACTIVITIES_ALLOWED_LIMIT) {
        const lastSelectedtaskIndex = this.selectedDataIDsArr.indexOf(task["taskID"]);
        this.selectedDataIDsArr.splice(lastSelectedtaskIndex, 1);
        this.$toastr.error("Selected activities cannot be greater than 1000.");
      }
    },
    updateSelectedText() {
      this.selectedText = "";
      if (this.input) {
        const selectedObj = this.input;
        if (this.input.length) {
          this.selectedText = this.input.length == 1 ? this.input[0][this.optionField] : "Selected Activities";
          this.selectedDataIDsArr = this.convertDataListToIdList(this.input, "taskID");
        }
        this.inputArrCount = selectedObj.length;
      }
    }
  },
  computed: {
    filteredList: {
      get() {
        return this.options.filter(opt => {
          return opt[this.optionField] && (opt[this.optionField].toLowerCase().indexOf(this.search.toLowerCase()) > -1 || (opt["taskType"] === "activity" ? "eDRO" : opt["taskType"] === "edro" ? "DRO" : opt["taskType"]).toLowerCase().indexOf(this.search.toLowerCase()) > -1);
        });
      },
      set(value) {
        /* this setter is only used because, otherwise this computed property was giving error, it has no other role to play */
        this.selectedDataArr = value;
      }
    },
    editInput() {
      this.updateSelectedText();
      return this.selectedText;
    }
  },
  watch: {
    actionData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        /* This will reset all the checkboxes to empty, if there is a change in the action type, at same index in actionsList.  */
        if (newData) {
          this.actionType = this.actionType ? this.actionType : newData.type;
          if (this.actionType !== newData.type) {
            this.actionType = newData.type;
            this.selectedDataIDsArr = [];
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.display-block {
  display: block;
}

.display-none {
  display: none;
}

.dd-placeholder {
  color: #b0bac9 !important;
  font-size: 13px;
  padding: 7px 17px !important;
  font-weight: normal;
}

.das-dropdown {
  border: solid 1px #d3dfe4;
  padding: 6px 17px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  margin-bottom: 15px;

  .activity-count {
    color: #4c8ce4;
    background-color: #d3dfe4;
    padding: 0.2px 6px 1px 5.5px;
    border-radius: 2px;
    margin-left: 9px;
    font-size: 12px;
    font-weight: 600;
    position: absolute;
    top: 7px;
  }

  .text-inline {
    text-overflow: ellipsis;
    max-width: 360px;
    overflow: hidden;
    white-space: nowrap;
  }

  .red-asterisk {
    color: #f16559;
    font-size: 14px;
    font-weight: bold;
    top: -0.2em;
  }

  .caret {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 6px solid #b0bac9;
    top: 14px;
    right: 7px;
    position: absolute;
  }

  ul {
    font-family: RobotoRegular;
    font-size: 15px;
    margin: 0;
    padding: 6px 0;
    list-style: none;
    position: absolute;
    z-index: 9;
    top: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    left: 0;
    box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 100%);

    li {
      display: block;
      text-decoration: none;
      color: #000;
      /* border-top: 1px solid #ffffff; */
      padding: 5px 15px 5px 15px;
      background: #ffffff;
      margin-left: 1px;
      white-space: nowrap;

      input[type="checkbox"] {
        box-sizing: border-box;
        cursor: pointer;
        padding: 0;
        margin-right: 11px;
        margin-top: auto;
        margin-bottom: auto;
        top: 2px;
        bottom: 0px;
        position: relative;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        outline: solid 1px #e2e7ea;
        border: none;
      }

      &.search-box-li {
        &:hover {
          background: rgba(0, 0, 0, 0);
        }
      }

      .search-wrapper {
        border: solid 1px #b0bac9;
        width: 100%;
        border-radius: 4px;
        padding: 3px 8px;
        display: flex;
        flex-wrap: nowrap;
        position: relative;

        input[type="search"] {
          border: none;
          width: 100%;
        }

        .search-cross {
          background: url(/static/img/search-cross.svg) no-repeat;
          display: block;
          height: 16px;
          width: 16px;
          top: 7px;
          position: absolute;
          right: 4px;
        }
      }

      .dropdown-list-item {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
      }

      .clearInputStyles {
        input[type="checkbox"] {
          margin-right: 0 !important;
          outline: none !important;
        }
      }

      .text-ellipsis {
        text-overflow: ellipsis;
        max-width: 300px;
        overflow: hidden;
        white-space: nowrap;

        /* &:hover{
                  overflow: visible;
                } */
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  ul::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 50px;
    border: 3px solid transparent;
  }

  ul::-webkit-scrollbar-track {
    background: transparent;
  }

  ul::-webkit-scrollbar {
    width: 4px;
  }
}

.popover-content {
  font-size: 13px;
  font-family: "RobotoRegular";
  color: #000;

  &.small-text {
    margin: 2px 1px;
  }

  &.large-text {
    margin: 6px 7px;
  }
}
</style>
